const BRL_FORMATTER = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

/** Formata um valor em CENTAVOS (padrão de armazenamento do módulo financeiro) para BRL. */
export function formatCentsBRL(cents: number | null | undefined): string {
  if (cents == null) return "-";
  return BRL_FORMATTER.format(cents / 100);
}

/**
 * Converte um valor digitado em reais para centavos inteiros. Aceita "1.500,50",
 * "1500,50", "1500.50" e "R$ 1.500": ponto só é decimal quando é o único
 * separador e tem 1 ou 2 casas depois dele.
 */
export function parseReaisToCents(value: string): number | null {
  let normalizado = value.trim().replace(/[R$\s]/g, "");
  if (normalizado === "") return null;
  if (normalizado.includes(",")) {
    normalizado = normalizado.replace(/\./g, "").replace(",", ".");
  } else if (!/^\d+\.\d{1,2}$/.test(normalizado)) {
    normalizado = normalizado.replace(/\./g, "");
  }
  const reais = Number(normalizado);
  if (!Number.isFinite(reais) || reais < 0) return null;
  return Math.round(reais * 100);
}

/** Centavos para o texto de um input em reais ("1500,50"). */
export function centsToReaisInput(cents: number | null | undefined): string {
  if (cents == null) return "";
  return (cents / 100).toFixed(2).replace(".", ",");
}

/** "10", "12,5": percentual pt-BR sem zeros à direita. */
export function formatPercent(value: number): string {
  return value.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
}
